module.exports = __webpack_public_path__ + "img/图片2-3.482b57fc.png";